import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "order-status flex" }
const _hoisted_3 = { class: "flex top-button-group" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增", -1)
const _hoisted_5 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "修改", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "dialog-fill" }, null, -1)
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "确定", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "取 消", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", {
        class: { 'mar-r-20 f-14': true, 'nav-range c-red': _ctx.NavIndex == 0 },
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx._nav(0)))
      }, "回访结果", 2),
      _createVNode("p", {
        class: { 'mar-r-20 f-14': true, 'nav-range c-red': _ctx.NavIndex == 1 },
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx._nav(1)))
      }, "自动回访建议", 2),
      _createVNode("p", {
        class: { 'mar-r-20 f-14': true, 'nav-range c-red': _ctx.NavIndex == 2 },
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx._nav(2)))
      }, "跟进类型", 2)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.NavIndex != 3&&_ctx.user.store_id == 0)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "bg-red mar-r-18",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialog_model = 'add'))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList[_ctx.NavIndex], (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "200"
          }, {
            default: _withCtx((scope) => [
              _createVNode("div", _hoisted_5, [
                (_ctx.NavIndex != 3&&_ctx.user.store_id == 0)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "btn-red",
                      onClick: ($event: any) => {_ctx.dialog_index = scope.$index; _ctx.dialog_model = 'edit'}
                    }, [
                      _hoisted_6
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.user.store_id == 0)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: "btn-red-line mar-l-8",
                      onClick: ($event: any) => (_ctx._upState(scope.row.id || scope.row.basicset_id, scope.row.basicset_status  == 0 ? 1 :0))
                    }, _toDisplayString(scope.row.is_use == 0  || scope.row.basicset_status == 0 ? '启动': '禁止'), 9, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "新增",
      "model-value": _ctx.dialog_model == 'add' || _ctx.dialog_model == 'edit',
      center: "",
      width: 1000,
      "before-close": ()=>{_ctx.dialog_model = false}
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx._submitForm
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialog_model = ''))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          ref: "formRef",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "basicset_name",
              "label-width": "100px",
              rules: [
                        {
                            required: true,
                            message: '必填',
                            trigger: 'blur',
                        },
                    ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.basicset_name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.basicset_name = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "排序",
              "label-width": "100px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.basicset_sort,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.basicset_sort = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _hoisted_7
      ]),
      _: 1
    }, 8, ["model-value", "before-close"])
  ]))
}